import { z } from 'zod';
import type { JWTPayload } from 'jose';

export const OptoutPayloadSchema = z
  .object({
    account_id: z.string(),
    brand: z.string(),
    consent: z.array(z.string()).nonempty(),
    iat: z.number(),
    exp: z.number(),
  })
  .and(z.object({} as unknown as JWTPayload)); // merge with JWTPayload

export type OptoutJwtTokenPayload = z.infer<typeof OptoutPayloadSchema>;
